export default __webpack_public_path__ + "static/media/post_payment.55c0363c.jpg";